import { useTranslation } from "react-i18next";
import { useBulkUpdateAdState } from "../../../modules/advertising/api/useBulkUpdateAdState";
import { AdToolPanel } from "../AdToolPanel";
import { Button } from "../Chat";
const AdStatusToolMessage = ({ adIds, state }) => {
  const { t } = useTranslation(["chat"]);
  const bulkUpdateAdState = useBulkUpdateAdState();
  const targetState = state === "paused" ? "paused" : "active";

  return (
    <AdToolPanel
      adIds={adIds}
      renderActions={({ ads, isLoading }) => {
        const adsForMutation = (ads ?? [])
          .map((ad) => ({
            id: Number(ad.ad_id),
            name: ad.ad_name ?? String(ad.ad_id),
          }))
          .filter((ad) => Number.isFinite(ad.id));
        const handleUpdateAdState = () => {
          if (!adsForMutation.length || bulkUpdateAdState.isPending) return;
          bulkUpdateAdState.mutate({ ads: adsForMutation, state: targetState });
        };
        const isButtonDisabled = bulkUpdateAdState.isPending || isLoading || !adsForMutation.length;
        const buttonLabel =
          bulkUpdateAdState.isPending ? t(($) => $.chat["Updating..."])
          : targetState === "paused" ? t(($) => $.chat["Pause Ads"])
          : t(($) => $.chat["Enable Ads"]);

        return (
          <Button onClick={handleUpdateAdState} disabled={isButtonDisabled}>
            {buttonLabel}
          </Button>
        );
      }}
    />
  );
};
export { AdStatusToolMessage };
